<template>
    <div class="notification">
        <p class="text text-center p-4">{{ notification }}</p>
    </div>
</template>

<script>
export default {
  name: 'SiteMessage',
  props: ['notification']
}
</script>

<style lang="scss" scoped>

</style>
